import React, { Component } from 'react';
import {connect} from "react-redux";
import { fetchBusinessHours } from '../../actions/users';
import viewHelper from '../../helpers/view';
import SelectSlot from "./selectSlot";
import FullCalendar from 'fullcalendar-reactwrapper';
import  'fullcalendar-reactwrapper/dist/css/fullcalendar.min.css'

class SelectDateTime extends Component {

    constructor (props) {
        super(props);
        this.state = { date: null };
    }

    handleDayClick(date) {
        let standardDate = viewHelper.getStandardDate(date);
        this.setState({ date: standardDate }, () => {
            this.props.fetchBusinessHours(this.props.trainer.id, standardDate);
        });
    }

    handleDayRender(date, cell) {
        if(date.format('YYYY-MM-DD') === this.state.date) {
            cell.addClass('current-date');
            document.querySelectorAll(`[data-date="${this.state.date}"]`)[1].classList.add('current-date');
        }
        return cell;
    }

    render () {
        return (
            <div className='date-time'>
                <div className='col-xs-12 col-md-12 col-lg-12 calendar'>
                    <FullCalendar
                        defaultDate={this.state.date}
                        dayRender={this.handleDayRender.bind(this)}
                        id='date-calendar'
                        contentHeight={225}
                        header={{left: 'prev,next today', right: 'title'}}
                        selectable={true}
                        dayClick={this.handleDayClick.bind(this)} />
                </div>
                <div className='col-xs-12 col-md-12 col-lg-12 slots'>
                    <SelectSlot{...this.props} date={this.state.date} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { businessHours } = state;
    return { businessHours };
}

export default connect(mapStateToProps, { fetchBusinessHours })(SelectDateTime);


// WEBPACK FOOTER //
// ./src/components/appointments/selectDateTime.js